import styled from 'styled-components';
import { setRem, setColor } from '../../utils/styles';

export const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Header = styled.div`
  display: flex;
  margin-bottom: ${setRem(60)};
`;

export const Logo = styled.img`
  display: block;
  height: ${setRem(80)};
  width: auto;
  margin-left: ${setRem(40)};
`;

export const Title = styled.h1`
  font-size: ${setRem(24)};
  line-height: 1.01;
  letter-spacing: -2px;
  text-transform: uppercase;
  text-decoration: none;
  font-weight: 700;
  display: inline-block;
  margin: ${setRem(24)} auto;
  color: ${setColor.primaryColor};

  & span {
    color: ${setColor.secondaryColor};
  }
`;

export const Text = styled.h2`
  font-size: ${setRem(32)};
  text-align: center;
`;
